export default "__VITE_ASSET__CqZC3PHG__"